// Бэкенд принимает filters только объектом {атрибут: значение | {operator, value}}.
// Генератор типизирует JsonType как string, поэтому JSON-строка или массив
// [{name, value}] проходят проверку типов, а сервер отвечает VALIDATION_FAILED
// (раньше — молча игнорировал и отдавал всю коллекцию).
// Литерал GraphQL вида `{entityUuid: "..."}` для типизированных input не трогаем.

type FilterItem = {name?: unknown, operator?: unknown, value?: unknown}

export function normalizeFiltersArg(value: unknown, source = 'filters'): unknown {
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed.startsWith('{"')) return value
    try {
      const parsed = JSON.parse(trimmed)
      console.warn(`[${source}] filters переданы JSON-строкой, нужен объект`, parsed)
      return parsed
    } catch {
      return value
    }
  }

  if (Array.isArray(value) && value.length > 0 && value.every(isNameValueItem)) {
    const result: Record<string, {operator: unknown, value: unknown}> = {}
    for (const item of value as FilterItem[]) {
      result[item.name as string] = {operator: item.operator ?? '=', value: item.value}
    }
    console.warn(`[${source}] filters переданы массивом {name, value}, нужен объект`, result)
    return result
  }

  return value
}

function isNameValueItem(item: unknown): boolean {
  return !!item && typeof item === 'object' && typeof (item as FilterItem).name === 'string' && 'value' in (item as object)
}

// Переменные типизированного клиента: аргумент filters может получить суффикс (filters, filters2...).
export function normalizeFiltersVariables(variables: unknown, source: string): unknown {
  if (!variables || typeof variables !== 'object') return variables
  const result: Record<string, unknown> = {...variables as Record<string, unknown>}
  for (const key of Object.keys(result)) {
    if (/^filters\d*$/.test(key)) {
      result[key] = normalizeFiltersArg(result[key], source)
    }
  }
  return result
}
